import { useMediaQuery, useTheme } from '@chakra-ui/react';
import { isString } from 'lodash';
import { useCallback } from 'react';

export type UseSizeOptions =
  | string
  | {
      base?: string;
      sm?: string;
      md?: string;
      lg?: string;
      xl?: string;
    };

export const useSizes = (size: UseSizeOptions = 'md') => {
  const theme = useTheme();
  const [isLargerThanSm] = useMediaQuery(theme.device.sm);
  const [isLargerThanMd] = useMediaQuery(theme.device.md);
  const [isLargerThanLg] = useMediaQuery(theme.device.lg);
  const [isLargerThanXl] = useMediaQuery(theme.device.xl);
  const getSize = useCallback(() => {
    if (isString(size)) return size;
    if (isLargerThanXl && size['xl']) return size['xl'];
    if (isLargerThanLg && size['lg']) return size['lg'];
    if (isLargerThanMd && size['md']) return size['md'];
    if (isLargerThanSm && size['sm']) return size['sm'];
    return size?.['base'];
  }, [size, isLargerThanMd, isLargerThanLg]);

  return {
    getSize,
  };
};
